import { useForm } from '@/common/form/FormContext';
import { DropdownSelect } from '@/common/form/formFields/DropdownSelect';
import { useEffect } from 'react';

// e.g. ('2025M02', 'QTR') -> '2025Q1'; ('2025Q3', 'MON') -> '2025M07'; going finer always picks the first sub-period
const convertPeriodCode = (periodCode, periodicity) => {
  const [, year, unit, n] = /^(\d{4})(?:([QM])(\d{1,2}))?$/.exec(periodCode);
  const month =
    unit === 'M' ? Number(n)
    : unit === 'Q' ? (Number(n) - 1) * 3 + 1
    : 1;
  if (periodicity === 'YEAR') return year;
  if (periodicity === 'QTR') return `${year}Q${Math.floor((month - 1) / 3) + 1}`;
  return `${year}M${String(month).padStart(2, '0')}`;
};

export const PeriodSelect = ({ fieldDef, periodicityToPeriods }) => {
  const { formValues, assignValue } = useForm();
  const periodicity = formValues.periodicity;
  const periods = periodicityToPeriods[periodicity];

  useEffect(() => {
    const selectedId = formValues[fieldDef.field];

    // The selected id belongs to the previous periodicity's list, so look it up across all lists
    const allPeriods = Object.values(periodicityToPeriods).flat();
    const selectedPeriodCode = allPeriods.find((period) => period.value === selectedId).displayName;
    const newPeriodCode = convertPeriodCode(selectedPeriodCode, periodicity);
    const newPeriodId = periods.find((period) => period.displayName === newPeriodCode).value;
    assignValue(fieldDef.field, newPeriodId);
  }, [periodicity]);

  const updatedFormFieldDef = {
    ...fieldDef,
    disabled: fieldDef.disabled || periods.length === 0,
    values: periods,
  };

  return <DropdownSelect fieldDef={updatedFormFieldDef} />;
};
